"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactOverlays = require("react-overlays");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FilterButton = _interopRequireDefault(require("../Buttons/FilterButton"));

var _DropdownContainer = _interopRequireDefault(require("./DropdownContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
// Components
const Li = _styledComponents.default.li.withConfig({
  displayName: "Filter__Li",
  componentId: "design-system__sc-14p6bsb-0"
})(["list-style:none;"]);

const Filter = _ref => {
  let {
    show,
    onToggle,
    drop,
    alignEnd,
    title,
    icon,
    children,
    active
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Li, null, /*#__PURE__*/_react.default.createElement(_reactOverlays.Dropdown, {
    show: show,
    onToggle: onToggle,
    drop: drop,
    alignEnd: alignEnd,
    itemSelector: "button:not(:disabled)"
  }, () => /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FilterButton.default, {
    icon: icon,
    active: active
  }, title), /*#__PURE__*/_react.default.createElement(_DropdownContainer.default, null, children))));
};

Filter.propTypes = {
  title: _propTypes.default.string.isRequired,
  show: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  drop: _propTypes.default.string,
  alignEnd: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  active: _propTypes.default.bool,
  icon: _propTypes.default.string
};
Filter.defaultProps = {
  show: undefined,
  drop: 'down',
  onToggle: undefined,
  alignEnd: false,
  active: false,
  icon: undefined
};
var _default = Filter;
exports.default = _default;